import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlotiqWhiteLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 1054 276",
	style: { enableBackground: "new 0 0 1054 276" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.flotiq-logo-white-st0{fill:#FFFFFF;}\n	.flotiq-logo-white-st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1c70e8;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st0",
			d: "M519,68.9v28.2h-90.7v29h86.5v28.2h-86.5v51.6h-31.2v-137H519z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st0",
			d: "M581.2,205.9c-11.1,0-19.7-2.6-25.8-7.9c-6.1-5.4-9.2-12.9-9.2-22.5V60.6h29.9v109.4c0,3.2,0.8,5.6,2.5,7.1 c1.7,1.5,4.4,2.3,8.1,2.3h8.9v26.5H581.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st0",
			d: "M673.7,208.4c-13,0-24.3-2.1-33.9-6.3c-9.6-4.3-16.9-10.4-22-18.4c-5.1-8.1-7.7-17.5-7.7-28.4v-2.7 c0-11.1,2.5-20.7,7.5-28.8c5.1-8.1,12.5-14.3,22-18.6c9.6-4.3,20.9-6.5,34.1-6.5c13,0,24.3,2.2,33.7,6.5 c9.4,4.3,16.6,10.5,21.6,18.6c5.1,8.1,7.7,17.7,7.7,28.8v2.7c0,10.9-2.6,20.3-7.7,28.4c-5,7.9-12.2,14.1-21.6,18.4 C697.9,206.3,686.7,208.4,673.7,208.4z M673.4,180.8c10.1,0,18-2.2,23.5-6.7c5.7-4.5,8.5-10.8,8.5-19v-2.3c0-8.5-2.8-15-8.3-19.6 c-5.5-4.6-13.4-6.9-23.7-6.9c-10.4,0-18.4,2.3-23.9,6.9c-5.5,4.5-8.3,11-8.3,19.6v2.3c0,8.2,2.8,14.5,8.3,19 C655.2,178.6,663.2,180.8,673.4,180.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st0",
			d: "M808,128v39.7c0,3.8,1,6.7,3.1,8.8c2.2,1.9,5.3,2.9,9.4,2.9H845v26.5h-28.5c-11.9,0-21.4-3.2-28.3-9.6 c-6.9-6.5-10.4-15.4-10.4-26.5V128h-34.7v-26.7H771c2.9,0,4.9-0.6,6-1.7c1.1-1.1,1.7-3.1,1.7-6.1v-20H808v27.8h43.3V128H808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st0",
			d: "M901.7,101.3v104.6h-29.9V101.3H901.7z M886.7,89.2c-5.5,0-10.1-1.6-13.5-4.8c-3.5-3.3-5.2-7.7-5.2-12.9 c0-5.3,1.7-9.5,5.2-12.7c3.5-3.3,8-5,13.5-5c5.7,0,10.2,1.7,13.5,5c3.5,3.2,5.2,7.4,5.2,12.7c0,5.3-1.7,9.6-5.2,12.9 C896.8,87.6,892.3,89.2,886.7,89.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st0",
			d: "M1053.1,101.3v140.1H1023v-43.2c-9.3,6.8-20.6,10.2-33.9,10.2c-12.2,0-22.9-2.2-32-6.7c-9-4.5-16-10.7-21-18.8 c-5-8.2-7.5-17.7-7.5-28.4v-2.1c0-10.7,2.4-20.1,7.3-28.2c5-8.2,12.1-14.5,21.2-18.8c9.2-4.5,19.8-6.7,32-6.7 c13.6,0,25.3,3.8,35.1,11.5l0.8-9H1053.1z M992,180.8c6.5,0,12.5-1,17.9-3.1c5.5-2.1,9.9-4.9,13.1-8.6v-31.3 c-3-3.6-7.3-6.4-12.9-8.3c-5.4-2.1-11.4-3.1-18.1-3.1c-10.1,0-18,2.3-23.7,6.9c-5.7,4.6-8.5,11-8.5,19.2v2.1 c0,8.4,2.8,14.8,8.5,19.4C974,178.5,981.9,180.8,992,180.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "flotiq-logo-white-st1",
			d: "M0,37.6C0,16.9,16.8,0,37.5,0H100c4.4,0,8.6,0.8,12.5,2.2c18.9,6.7,36.2,22.9,56.2,22.9s37.3-16.2,56.2-22.9 c3.9-1.4,8.1-2.2,12.5-2.2C258.2,0,275,16.9,275,37.6s-16.8,37.6-37.5,37.6c-4.4,0-8.6-0.8-12.5-2.2c-18.9-6.7-36.2-22.9-56.2-22.9 s-37.3,16.2-56.2,22.9c-3.9,1.4-8.1,2.2-12.5,2.2H37.5C16.8,75.3,0,58.4,0,37.6z M0,138c0-20.8,16.8-37.6,37.5-37.6 c5.5,0,10.7,1.2,15.4,3.3c16.5,7.5,32,21.8,50.2,21.8c18.1,0,33.7-14.3,50.2-21.8c4.7-2.1,9.9-3.3,15.4-3.3 c20.7,0,37.5,16.8,37.5,37.6s-16.8,37.6-37.5,37.6c-5.5,0-10.7-1.2-15.4-3.3c-16.5-7.5-32-21.8-50.2-21.8 c-18.1,0-33.7,14.3-50.2,21.8c-4.7,2.1-9.9,3.3-15.4,3.3C16.8,175.6,0,158.8,0,138z M37.5,200.7C16.8,200.7,0,217.6,0,238.4 S16.8,276,37.5,276S75,259.1,75,238.4S58.2,200.7,37.5,200.7z"
		})
	]
});
export default SvgFlotiqWhiteLogo;
